<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="checkboxChange"
      @deleteItems="deleteItems"
      @openEditForm="openEditForm"
    >
      <template #header>
        <PageHeader
          ref="header"
          :isLast="isLast"
          :isTop="isTop"
          @query="getData"
          @reset="resetPage"
          @openChooseUser="openChooseUser"
          @delUser="delUser"
          @syncDepUser="syncDepUser"
        />
      </template>
      <template #pager>
        <pagination
          size="small"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </template>
    </PageMain>
    <ChooseSysUser
      :visible.sync="visible"
      width="1000px"
      confirmOnClose
      multiple
      @confirm="onConfirm"
      :extraData="extraData"
    ></ChooseSysUser>
  </div>
</template>

<script>
import BaseTable from "@/mixins/base-table";
import EditLoading from "@/mixins/edit-loading";
import PageMain from "./Main.vue";
import PageHeader from "./Header.vue";
import ChooseSysUser from "../ChooseSysUser/index.vue";
export default {
  components: {
    ChooseSysUser,
    PageMain,
    PageHeader,
  },
  props: {
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      checkedRows: [],
      extraData: {},
      visible: false,
      usePage: true,
      editFormOption: {
        visible: false,
        subgroupMemberCode: "",
        userName: "",
        userCode: "",
      },
    };
  },
  computed: {
    isLast() {
      return this.currentRow?.isLast == "Y";
    },
    isTop() {
      return this.currentRow?.isTop == "Y";
    },
  },
  watch: {
    currentRow: {
      handler() {
        this.$refs.header.query();
      },
      deep: true,
    },
  },
  methods: {
    getData(form) {
      this.loading = true;
      this.$api
        .factoryMrpSubgroupMemberListApi({
          ...form,
          ...this.page,
          subgroupCode: this.currentRow?.subgroupCode,
        })
        .then((res) => {
          this.loading = false;
          this.setData(res);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async checkboxChange(data) {
      this.checkedRows = data;
    },
    async openChooseUser() {
      this.visible = true;
    },
    async syncDepUser() {
      const confirm = await this.$confirm(
        this.$l("message_sync_dep_user_record") || "确认要同步生产线人员吗？",
        this.$l("INDEX.tips_title_confirm") || "确认信息",
        {
          type: "warning",
          draggable: true,
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          confirmButtonText: this.$l("INDEX.btn_confirm") || "确认",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirm) return;
      const subgroupCode = this.currentRow?.subgroupCode;
      if (!subgroupCode) return;
      if (this.loadingOpen()) return;
      const res = await this.$api
        .factoryMemberSyncUserApi({ subgroupCode })
        .catch(() => null);
      this.loadingClose();

      if (!res) return;
      const { status, msg } = res;
      const isWarning = status !== 200;
      this.$message({
        showClose: true,
        message: msg,
        type: isWarning ? "warning" : "success",
      });
      if (isWarning) return;

      this.reload();
      this.$emit('reloadTree')
    },
    async delUser() {
      if (this.checkedRows.length) {
        await this.deleteItems(
          this.checkedRows.map((e) => e.subgroupMemberCode)
        );
      }
    },
    async deleteItems(codes) {
      const confirm = await this.$confirm(
        this.$l("message_del_check_record") || "确认要删除选择的记录吗？",
        this.$l("INDEX.tips_title_confirm") || "确认信息",
        {
          type: "warning",
          draggable: true,
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          confirmButtonText: this.$l("INDEX.btn_confirm") || "确认",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirm) return;

      if (this.loadingOpen()) return;
      const res = await this.$api
        .factoryMrpSubgroupMemberDelApi({ codes })
        .catch(() => null);
      this.loadingClose();

      if (!res) return;
      const { status, msg } = res;
      const isWarning = status !== 200;
      this.$message({
        showClose: true,
        message: msg,
        type: isWarning ? "warning" : "success",
      });
      if (isWarning) return;

      this.reload();
    },
    async onConfirm(data) {
      const userCodes = data.map((e) => e.userCode);
      const subgroupCode = this.currentRow?.subgroupCode;
      if (!subgroupCode) return;

      if (this.loadingOpen()) return;
      const res = await this.$api
        .factoryMrpSubgroupMemberSaveApi({
          userCodes,
          subgroupCode,
        })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;

      const { status, msg } = res;
      const isWarning = status !== 200;
      this.$message({
        showClose: true,
        message: msg,
        type: isWarning ? "warning" : "success",
      });
      if (isWarning) return;

      this.reload();
    },
    async openEditForm({ subgroupMemberCode, userName, userCode }) {
      this.editFormOption.subgroupMemberCode = subgroupMemberCode;
      this.editFormOption.userName = userName;
      this.editFormOption.userCode = userCode;
      this.editFormOption.visible = true;
    },
    async openImportProduct() {
      this.importProductVisible = true;
    },
  },
};
</script>
